import { ConnectedDevice } from '../connected-device.model';

export class LpcuDetailsLocation
{
    constructor(json: any = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    Name: string;
    UtcOffset: number;
    ConnectedDevices: ConnectedDevice[];

    get GatewayName(): string {
        return (this.ConnectedDevices && this.ConnectedDevices.length > 0) ? this.ConnectedDevices[0].Name : '';
    }
}
